<template>
    <section id="page-ten-eerste" class="page-ten-eerste page">
        <div class="page__content">
            <h1>HOOGSTE TIJD OM JE EIGEN HYBRIDE DOCENT-PROFIEL TE VORMEN. RECHTS IN BEELD LOOPT JOUW PERSOONLIJKE PROFIEL MEE.</h1>
            <div class="container list-select">
                <div class="row">
                    <div class="col-2-sm"></div>
                    <div class="col-10-sm list-select__title">Ik ben</div>
                </div>
                <div class="list-select__item row" v-for="type in jobTypes"
                     v-bind:class="{'list-select__item--selected': type === currentJob}"
                     v-on:touchstart="selectType(type)"
                     v-on:click="selectType(type)">
                    <div class="col-2-sm list-select__item-marker-column">
                        <div class="list-select__item-marker"></div>
                    </div>
                    <div class="col-10-sm list-select__item-text">
                        {{type.label}}
                    </div>
                </div>
                <div class="row" v-if="currentJob">
                    <div class="col-2-sm"></div>
                    <div class="col-10-sm list-select__title">
                        <button class="button"
                                v-on:touchstart="submitHandler"
                                v-on:click="submitHandler">Volgende</button>
                    </div>
                </div>
                <div class="result-anchor"></div>
                <p class="result-box" v-if="submitted">
                    Oké! Er zijn talloze combinaties mogelijk. Je hebt al gezien dat dé hybride docent niet bestaat. Laten we snel doorgaan met de volgende vraag.
                    <page-next-button v-if="submitted"
                                      v-on:touchstart="nextHandler"
                                      v-on:click="nextHandler"></page-next-button>
                </p>
            </div>

        </div>
    </section>
</template>
<style lang="stylus">
    .page-ten-eerste .list-select
        margin-bottom 30px;

</style>
<script>
    const ScrollMagic = require('ScrollMagic');
    const TimelineMax = require('TimelineMax');
    import page from './page';

    export default {
        mixins: [page],
        props: {
            jobTypes: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                currentJob: null,
                submitted: false
            }
        },
        methods: {
            selectType(type) {
                this.currentJob = type;
                this.submitted = false;
                this.$emit('profileupdate', { key: 'baan1', value: type });
            },
            submitHandler() {
                this.submitted = true;
                TweenLite.to(window, 1, {scrollTo: '.page-ten-eerste .result-anchor'});
            }
        }

    }
</script>



// WEBPACK FOOTER //
// page-ten-eerste.vue?6e4090a4